import { ca } from '@cian/analytics';

export function trackBuildRouteClose() {
  ca('eventSite', {
    action: 'close',
    category: 'Infrastructure',
    label: 'route_button',
    name: 'oldevent',
    useLastProducts: true,
  });
}
